module.exports = __webpack_public_path__ + "img/11For_Corporate.8bda7be6.png";